import { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import { trackExistingUserRedirectTo } from '@/components/signup/utils/analytics';
import { IBxpWebStargateClient } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client';
import {
	AuthenticationMethodsType,
	CheckAuthenticationMethodsAvailableResponse,
} from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

export type GetMethodsAvailableRedirectionOptions = {
	email: string;
	application?: string;
	signupClient: IBxpWebStargateClient;
	createAnalyticsEvent: CreateUIAnalyticsEvent;
	successRedirect: string;
};

export async function getMethodsAvailableRedirection({
	email,
	application,
	signupClient,
	createAnalyticsEvent,
	successRedirect,
}: GetMethodsAvailableRedirectionOptions) {
	const response = await signupClient.checkAuthenticationMethodsAvailable({
		email,
		application,
		successRedirect,
	});

	const authenticationMethod = getAuthenticationMethod(response);

	if (!!authenticationMethod) {
		trackExistingUserRedirectTo(createAnalyticsEvent, authenticationMethod.type);
	}

	return authenticationMethod?.redirect_to;
}

const getAuthenticationMethod = (
	authenticationMethods: CheckAuthenticationMethodsAvailableResponse,
) => {
	const userExists =
		!!authenticationMethods?.methods && authenticationMethods.methods?.length !== 0;

	if (!userExists) {
		return undefined;
	} else {
		const samlMethod = authenticationMethods.methods.find((method) => {
			return (
				method.type === AuthenticationMethodsType.SAML ||
				method.type === AuthenticationMethodsType.GOOGLE
			);
		});

		const passwordMethod = authenticationMethods.methods.find((method) => {
			return method.type === AuthenticationMethodsType.PASSWORD;
		});

		if (userExists && passwordMethod) {
			return passwordMethod;
		}

		if (!passwordMethod && samlMethod) {
			return samlMethod;
		} else {
			return undefined;
		}
	}
};
